import { render } from "./GpsDataChart.vue?vue&type=template&id=2bda0eb4&scoped=true"
import script from "./GpsDataChart.vue?vue&type=script&lang=js"
export * from "./GpsDataChart.vue?vue&type=script&lang=js"

import "./GpsDataChart.vue?vue&type=style&index=0&id=2bda0eb4&scoped=true&lang=css"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bda0eb4"]])

export default __exports__